<template>
    <div class="col-md-12">
        <button class="btn btn-success" style="border-radius: 2px !important;" @click="openModalGroup()">
            <i class="fas fa-users"></i> Adicionar novo base (grupo)
        </button>

        <b-row>
            <b-col md="12">
                <b-table striped hover bordered sort-icon-left show-empty :items="tbData" :fields="fields"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
                    :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold">

                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Processando, por favor, aguarde...
                        </div>
                    </template>

                    <template v-else #empty>
                        <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
                    </template>

                    <template #cell(createdAt)="data">
                        {{ formatDate(data.item.createdAt) }}
                    </template>

                    <template #cell(members)="data">
                        <span v-for="member in data.item.members" :key="member._id" class="badge badge-primary badge-member">{{ member.name }}</span>
                    </template>

                    <template v-slot:cell(view-button)="{ item }">
                        <span>
                            <b-btn id="view-button" @click.prevent="openModalGroup(item)" style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6" label-align-sm="right"
                    label-size="sm" class="mb-0 align-self-center">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                    class="my-0"></b-pagination>
            </b-col>
        </b-row>

        <GroupsTaskModal ref="addGroupModal" @updateGroupTable="updateTable"></GroupsTaskModal>
    </div>
</template>

<script>
import GroupsTaskModal from './GroupsTaskModal.vue';
import { formatDate } from '../../../helpers/utils';
import { taskManagerAxios } from '../connections/taskApiConnection';

export default {
    name: "ManageTaskGroups",
    components: { GroupsTaskModal },
    data() {
        return {
            tbData: [],
            usersMap: {},
            loading: false,
            fields: [
                {
                    key: 'createdAt',
                    label: 'Data',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'members',
                    label: 'Membros',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }
                },
                {
                    key: 'view-button',
                    label: 'Visualizar',
                    sortable: false,
                    class: 'text-center',
                    thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
                },
            ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
            sortBy: '',
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
    },
    created() {
        this.getDataTable();
    },
    methods: {
        formatDate,
        openModalGroup(value = null) {
            this.$refs.addGroupModal.openModal(value);
        },
        async getDataTable() {
            try {
                const [groupsRes, usersRes] = await Promise.all([
                    taskManagerAxios.get('/groups/by-tag/co'),
                    taskManagerAxios.get('/users'),
                ]);
                this.usersMap = Object.fromEntries(usersRes.data.map(u => [u._id, u]));
                this.tbData = groupsRes.data.map(group => ({
                    ...group,
                    members: (group.members ?? []).map(m =>
                        typeof m === 'object' ? m : (this.usersMap[m] ?? { id: m, name: m })
                    ),
                }));
                this.totalRows = this.tbData.length;
            } catch (error) {
                console.error(error);
            }
        },
        updateTable(data) {
            if (!data._id) return;
            const resolved = {
                ...data,
                members: (data.members ?? []).map(m =>
                    typeof m === 'object' ? m : (this.usersMap[m] ?? { id: m, name: m })
                ),
            };
            const idx = this.tbData.findIndex(el => el._id === data._id);
            if (idx !== -1) {
                this.$set(this.tbData, idx, resolved);
            } else {
                this.tbData.push(resolved);
                this.totalRows++;
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    }
}
</script>

<style scoped>
.badge-member {
    margin: 0px 5px;
    font-size: 1em;
}
</style>
